import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShiftTemplateFilterEntity } from '../../domain/entities/ShiftTemplateFilterEntity'
import moment from 'moment'

export class ShiftTemplateFilterModel extends ShiftTemplateFilterEntity {
  fromStartTime?: string
  toStartTime?: string
  fromDuration?: string
  toDuration?: string
  regionId?: number
  constructor(dataDto: ShiftTemplateFilterEntity) {
    super()
    mapEntityProperties<ShiftTemplateFilterModel>(this, dataDto, {
      exclude: ['time', 'duration'],
      map: {
        fromStartTime: dataDto.time
          ? dataDto.time[0]
            ? moment(dataDto.time[0]).format('HH:mm:ss')
            : undefined
          : undefined,
        toStartTime: dataDto.time
          ? dataDto.time[1]
            ? moment(dataDto.time[1]).format('HH:mm:ss')
            : undefined
          : undefined,
        fromDuration: dataDto.duration
          ? dataDto.duration[0]
            ? moment(dataDto.duration[0]).format('HH:mm:ss')
            : undefined
          : undefined,
        toDuration: dataDto.duration
          ? dataDto.duration[1]
            ? moment(dataDto.duration[1]).format('HH:mm:ss')
            : undefined
          : undefined,
        regionId: dataDto.region?.id
      }
    })
  }
}
